import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';

import Logout from '../../assets/svg/LogOutIcon';
import * as routing from '../../constants/Routing';
import { useAsUser } from '../../hooks/session/useAsUser';
import useDeleteSession from '../../hooks/session/useDeleteSession';
import Text from '../../react-components/Text';

export const OnboardingTopBar = ({ color }: { color?: string }) => {
  const { asUser, deleteAsUser } = useAsUser();
  const { run: logout } = useDeleteSession();

  return (
    <>
      {!!asUser && asUser !== `` ? (
        <div
          style={{
            padding: `10px 20px`,
            position: `absolute`,
            left: 0,
            zIndex: 1,
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            onClick={() => {
              deleteAsUser();
              window.open(`${window.location.origin}${routing.PRIVATE_HIGHWAY}`, `_self`);
            }}
          >
            <NoAccountsIcon style={{ cursor: `pointer`, color: color ?? RoutalPalette.text }} />

            <HSpacer small />

            <Text style={{ cursor: `pointer`, color: color }}>Back to root</Text>
          </Grid>
        </div>
      ) : null}

      <div
        style={{
          padding: `10px 20px`,
          position: `absolute`,
          right: 0,
          zIndex: 1,
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          onClick={() => {
            logout();
          }}
        >
          <Grid item style={{ display: `flex`, marginRight: `4px` }}>
            <Logout color={color ?? RoutalPalette.neutral00} width="18px" height="18px" />
          </Grid>

          <Grid item>
            <Text
              intlId="company.onboarding.logout"
              style={{ cursor: `pointer`, color: color ?? RoutalPalette.neutral00 }}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
